import Panel from '@admin/components/panel'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Plans)',
  collection: {
    endpoint: `/api/admin/subscriptions/services/${props.service.id}/plans`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true },
      { label: 'Price', key: 'price', primary: true, collapsing: true, format: 'currency' }
    ],
    defaultSort: { key: 'title', order: 'asc' },
    empty: {
      icon: 'clone',
      title: 't(No Plans)',
      text: 't(You have not created any plans for this service)',
      buttons: [
        { label: 'Create Plan', modal: <New service={ props.service } /> }
      ]
    },
    entity: 'plan',
    onClick: (record) => context.router.push(`/admin/subscriptions/services/${props.service.id}/plans/${record.id}`)
  },
  task: {
    svg: 'plus',
    modal: <New service={ props.service } />
  }
})

export default Panel(null, mapPropsToPanel)
